export default "__VITE_ASSET__27ac59d2__"